import { gql } from '@apollo/client';

export const GET_ALL_WEBHOOKS = gql`
  query fetchWebhooks {
    fetchUserWebhooks {
      _id
      uid
      secretKey
      webhooksList {
        id
        status
        name
        events
        encrypted
        url
      }
    }
  }
`;

export const GET_WEBHOOK_HISTORY = gql`
  query FetchWebhookEvents(
    $filter: WebhookEventFilterInput
    $pagination: WebhookEventPaginationInput
  ) {
    fetchWebhookEvents(filter: $filter, pagination: $pagination) {
      events {
        _id
        pid
        events
        pnum
        eventName
        status
        timestamp
        endpoint
      }
      nextCursor
      hasMore
      totalCount
    }
  }
`;
